import {post} from "../../../api/api";
//import {getResponse, handleHttpError} from "../../../api/api";

export function getUrlBase() {
  let {subDomain} = document.kvConfig;
  let {domain} = document.kvConfig;
  domain = domain || 'quotesflooring.com';
  subDomain = subDomain ? subDomain + '.' : '';

  return (location.port === "9007" || document.kvConfig.kioskMode) ? `${subDomain}${domain}` : "";
}

export const sqftPost = async (url, data, options = {}) => {
  return post(url, data, options);
  //void post;

  // const fullUrl = 'https://quotekitchenandbath.com' + url;
  // const isFormData = Object.prototype.toString.call(data) === '[object FormData]';
  // const headers = {
  //   'Accept': 'application/json'
  // };
  // if (!isFormData) {
  //   headers['Content-Type'] = 'application/json';
  // }
  //
  // return fetch(fullUrl, {
  //   method: 'post',
  //   body: isFormData ? data : JSON.stringify(data),
  //   headers: new Headers(headers),
  //   signal: options.signal,
  // })
  //   .then(handleHttpError)
  //   .then(response => getResponse(response))
  //   .catch(reason => {
  //     if (reason.name === 'AbortError') {
  //       console.log('Fetch aborted');
  //     } else {
  //       return Promise.reject(reason);
  //     }
  //   });
};

export const fetchDataWithCancellation = (url, key, shouldSaveDataInStore = false) => {
  return async () => {
    const controller = new AbortController();
    const signal = controller.signal;

    store.dispatch({ type: 'REQUEST_STARTED', payload: { key, controller } });

    try {
      const response = await fetch(url, { signal });
      if (!response.ok) {
        throw new Error('Network response was not ok.');
      }

      const data = await response.json();
      store.dispatch({ type: 'REQUEST_SUCCESS', payload: { key, data: shouldSaveDataInStore ? data : null} });

      return data
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('Fetch aborted:', key);
      } else {
        store.dispatch({ type: 'REQUEST_FAILURE', payload: { key, error: error.message } });
      }
    }
  };
};

export const cancelFetch = (key) => {
  return () => {
    const state = store.getState();
    const controller = state.sqftState.requests[key];

    if (controller) {
      controller.abort();
      store.dispatch({ type: 'REQUEST_CANCELLED', payload: { key } });
      store.dispatch({ type: 'REMOVE_CONTROLLER', payload: { key } });
    }
  };
};
